import { render, staticRenderFns } from "./TrafficSourceEdit.vue?vue&type=template&id=f33f76c2&scoped=true"
import script from "./TrafficSourceEdit.vue?vue&type=script&lang=js"
export * from "./TrafficSourceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f76c2",
  null
  
)

export default component.exports